'use strict';

var _reactTransformCatchErrors2 = require('react-transform-catch-errors');

var _interopRequireDefault = require('babel-runtime/helpers/interop-require-default')['default'];

var _reactTransformCatchErrors3 = _interopRequireDefault(_reactTransformCatchErrors2);

var _react = require('react');

var _redboxReact = require('redbox-react');

var _inherits = require('babel-runtime/helpers/inherits')['default'];

var _createClass = require('babel-runtime/helpers/create-class')['default'];

var _classCallCheck = require('babel-runtime/helpers/class-call-check')['default'];

exports.__esModule = true;

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _reactRouter = require('react-router');

var _components2 = require('../../components');

var _components = {
  _$PostDetails: {
    displayName: 'PostDetails'
  }
};

var _reactComponentWrapper = _reactTransformCatchErrors3['default']({
  filename: '/var/www/websites/blog.paymentwall.com/releases/20220825105928/src/components/PostSingle/PostDetails.js',
  components: _components,
  locals: [],
  imports: [_react, _redboxReact]
});

var _reactComponentWrapper2 = _reactTransformCatchErrors3['default']({
  filename: '/var/www/websites/blog.paymentwall.com/releases/20220825105928/src/components/PostSingle/PostDetails.js',
  components: _components,
  locals: [],
  imports: [_react, _redboxReact]
});

function _wrapComponent(uniqueId) {
  return function (ReactClass) {
    return _reactComponentWrapper2(_reactComponentWrapper(ReactClass, uniqueId), uniqueId);
  };
}

var PostDetails = (function (_Component) {
  _inherits(PostDetails, _Component);

  function PostDetails() {
    _classCallCheck(this, _PostDetails);

    _Component.apply(this, arguments);
  }

  PostDetails.prototype.renderTimeAgo = function renderTimeAgo(datetime) {
    var moment = require('moment');
    var date = new Date(datetime);
    var now = new Date(Date.now());

    if (moment(now).diff(moment(date), 'days') < 1) {
      return moment(date).fromNow();
    }

    return moment(date).format('MMM D, YYYY');
  };

  PostDetails.prototype.renderPostViews = function renderPostViews(views) {
    return Math.round(1500 * Math.pow(views, 0.5));
  };

  PostDetails.prototype.renderDetails = function renderDetails() {
    // todo add details var after fix
    var _props = this.props;
    var post = _props.post;
    var loading = _props.loading;

    if (loading) {
      return _react2['default'].createElement(_components2.AppLoader, { theme: 'light', size: '25' });
    }

    return _react2['default'].createElement(
      'div',
      { className: 'col-xs-12 col-sm-6 col-sm-offset-3 animated fadeInUp' },
      _react2['default'].createElement(
        'div',
        { className: 'post-details__categories' },
        post.categories.names.map(function (category) {
          return _react2['default'].createElement(
            _reactRouter.Link,
            { to: '/' + category.name, className: 'post-details__categories-item btn btn--bordered', key: category.id },
            category.name
          );
        })
      ),
      _react2['default'].createElement(
        'div',
        { className: 'post-details__meta' },
        'By ',
        _react2['default'].createElement(
          'span',
          { className: 'post-details__meta-author' },
          post.author_name,
          ','
        ),
        ' ',
        _react2['default'].createElement(
          'span',
          { className: 'post-details__meta-date' },
          this.renderTimeAgo(post.date)
        )
      ),
      _react2['default'].createElement(
        'div',
        { className: 'post-details__stats' },
        _react2['default'].createElement('div', { className: 'social-items social-items--stats' })
      )
    );
  };

  PostDetails.prototype.render = function render() {
    return _react2['default'].createElement(
      'div',
      { className: 'post-details' },
      _react2['default'].createElement(
        'div',
        { className: 'container' },
        _react2['default'].createElement(
          'div',
          { className: 'row' },
          this.renderDetails()
        )
      )
    );
  };

  _createClass(PostDetails, null, [{
    key: 'propTypes',
    value: {
      post: _react.PropTypes.object.isRequired,
      details: _react.PropTypes.object,
      loading: _react.PropTypes.bool.isRequired
    },
    enumerable: true
  }]);

  var _PostDetails = PostDetails;
  PostDetails = _wrapComponent('_$PostDetails')(PostDetails) || PostDetails;
  PostDetails = _reactRedux.connect(function (state) {
    return {
      // details: state.details.data,
      loading: state.details.loading
    };
  })(PostDetails) || PostDetails;
  return PostDetails;
})(_react.Component);

exports['default'] = PostDetails;
module.exports = exports['default'];
/* <div className="social-items__item social-items__item--default">
 <div className="social-items__item-icon">
   <svg className="icon icon--facebook" viewBox="0 0 11 22">
      <use xlinkHref="#icon-facebook"></use>
   </svg>
 </div>
 <span className="social-items__item-value">{details.facebook}</span>
</div> */ /* <div className="social-items__item social-items__item--default">
           <div className="social-items__item-icon">
             <svg className="icon icon--linkedin" viewBox="0 0 22 22">
                <use xlinkHref="#icon-linkedin"></use>
             </svg>
           </div>
           <span className="social-items__item-value">{details.linkedin}</span>
          </div> */ /* <div className="social-items__item social-items__item--default social-items__item--last">
                     <div className="social-items__item-icon">
                       <svg className="icon icon--pulse" viewBox="0 0 29 20">
                          <use xlinkHref="#icon-pulse"></use>
                       </svg>
                     </div>
                     <span className="social-items__item-value">{this.renderPostViews(details.views)}</span>
                    </div> */


//////////////////
// WEBPACK FOOTER
// ./src/components/PostSingle/PostDetails.js
// module id = 671
// module chunks = 0